export const Shadow = {
	1: '-7.45455px -7.45455px 9.31818px #FFFFFF, 4.65909px 4.65909px 18.6364px #BABECC',
	2: '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
};
